import { render, staticRenderFns } from "./VirtualContractDocumentsWidget.vue?vue&type=template&id=16ac764f&scoped=true&"
import script from "./VirtualContractDocumentsWidget.vue?vue&type=script&lang=js&"
export * from "./VirtualContractDocumentsWidget.vue?vue&type=script&lang=js&"
import style0 from "./VirtualContractDocumentsWidget.vue?vue&type=style&index=0&id=16ac764f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ac764f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16ac764f')) {
      api.createRecord('16ac764f', component.options)
    } else {
      api.reload('16ac764f', component.options)
    }
    module.hot.accept("./VirtualContractDocumentsWidget.vue?vue&type=template&id=16ac764f&scoped=true&", function () {
      api.rerender('16ac764f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/VirtualContractDocumentsWidget.vue"
export default component.exports